import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { T } from 'containers';
// import moment from 'moment';

import { AppText } from 'domain/appText';
import GlowHeading from '../../../components/Atoms/GlowHeading';
import Container from '../../../components/Atoms/Container';
import GuestWarning from './GuestWarning';
import BrowserWarningContainer from '../../../containers/BrowserWarning';
import ImportFileContainer from '../../../containers/ImportFile';
import LanguageDropdownContainer from '../../../containers/LanguageDropdown';
import './styles.css';
import ServerSaveStatus from '../../../containers/ServerSaveStatus';
import LogoHandler from '../../../containers/LogoHandler';

const BgGrid = styled.div`
  background-color: #004a93;
  height: auto;
`;

const ContainerHeader = styled(Container)`
  display: flex;
  flex-direction:row;
  justify-content:space-between;
  position: relative;
  height: 70px;
`;

const ReservationChooser = styled.div`
  background-color: #003973;
  color: white;
  padding: 15px 20px;
  font-size: 12px;
  line-height: 1em;
  font-family: sans-serif;
  position: absolute;
  right: 0;
  height: 40px;
  width: 120px;

  span{
    display: block;
    font-size: 2em;
    line-height: 1.2em;
    font-weight: bold;
  }
`;

const GlowHeadingWhite = styled(GlowHeading)`
  color: white;
  padding: 0px 30px;
  line-height: 73px;
  height: 70px;
  font-size: 36px;
  width: 45%;
  position: absolute;
  left: 0;
  font-family: sans-serif;
`;

const AllocInfo = styled.div`
  font-size: 1em;
  line-height: 1em;
  padding: 10px 20px;
  text-align: center;
  background-color: #ffebb2;
  border: 1px solid #f2d891;
  color: #99740f;
  font-family: sans-serif;
  margin: 10px;

  img{
    width: 20px;
    height: auto;
    display: inline-block;
    vertical-align: middle;
    margin-right: 10px;
  }
  p{
    display: inline-block;
    vertical-align: middle;
    margin: 0;
  }
`;

const VisumArea = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    white-space: nowrap;
    background-color: #fff;
    color: #935ba6;
    text-align: center;
    font-size: 13px;
    font-family: sans-serif;
    position: relative;
    height: 45px;
    padding: 0px 10px;
    border-right: 1px solid #CCC;
    border-left: 1px solid #CCC;
    ::before{
      display: block;
      position: relative;
      margin: 0px 10px;
      content: ' ';
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 0px 12px 12px 0;
      border-color: transparent #935ba6 transparent transparent;
    }

  h4{
    margin: 0;
    font-size: 1em;
    display: inline-block;
    vertical-align: top;
    margin-right: 10px;
  }

  span{
    content: ' ';
    display: inline-block;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 0 15px 15px 0;
    border-color: transparent #935ba6 transparent transparent;
    margin: 0px 5px 0px;
    vertical-align: middle;
  }
`;

const SaveAndErrorArea = styled.div`
  display:flex;
  justify-content:center;
  align-items:center;
  background-color: #ecf2f8;
  padding: 25px 0px;
  font-family: sans-serif;

  &.sticky {
    position: fixed;
    display: flex;
    align-items: center;
    justify-content: center;
    top: 0px;
    z-index: 100;
    width: 100%;
    background-color: #fff;
    height: 70px;
    margin: 0px;
    padding: 0px;
    left: 50%;
    transform: translateX(-50%);
  }
`;

const SaveAndErrorAreaRow = styled.div`
  display:flex;
  justify-content:center;
  align-items:center;
  box-shadow: 0px 0px 10px #CCC;
  border-radius: 12px;
`;

const InputFieldRequired = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    white-space: nowrap;
    position:relative;
    text-align: center;
    outline:none;
    transition: min-width 0.5s;
    width: auto;
    height: 45px;
    font-size: 13px;
    font-family: sans-serif;

    &.expanded {
      transition: all 0.5s;
    }
`;

const InputFieldRequiredTitleContainer = styled.div`
    cursor: pointer;
    display: flex;
    align-items: center;
    overflow: hidden;
    background-color: #ffffff;
    color: #990f0f;
    justify-content: space-around;
    height: 100%;
    padding: 0px 10px;
    border-radius: 12px 0px 0px 12px;

`;
const InputFieldRequiredError = styled.img`
    width: 24px;
    height: 24px;
    margin-right: 15px;
    margin-left: 10px;

`;
const InputFieldRequiredTitle = styled.div`
    min-width: 40px;
    display: flex;
    flex-direction: row;
    span {
      margin-right:5px;
    }
`;
const InputFieldRequiredArrow = styled.img`
    width: 16px;
    height: 16px;
    margin-right: 15px;
    margin-left: 10px;
    margin-bottom: 2px;
    &.expanded {
      transform: rotate(180deg);
      -webkit-transform: rotate(180deg);
    }
`;

const DropDownFieldRequired = styled.ul`
    position: absolute;
    top: 54px;
    left: 0;
    max-height: 250px;
    overflow-y: auto;
    width: 230px;
    background-color: #ffcfcf;
    border: 1px solid #f2acac;
    list-style-type: none;
    box-sizing: border-box;
    padding: 0;
    margin: 0px;
    box-shadow: 0px 5px 10px 0px rgba(0,0,0,0.2);

    li{
      margin: 0;

      ul{
        padding-inline-start: 25px;
        list-style-type: disc;
      }
    }

    li:hover{
      background-color: white;
    }

    ::-webkit-scrollbar {
        width: 5px;
    }

    ::-webkit-scrollbar-track {
        background: #ffffff;
    }

    ::-webkit-scrollbar-thumb {
        background: #888;
    }

    ::-webkit-scrollbar-thumb:hover {
        background: #555;
    }
`;


const LanguageSection = styled.div`
  display: flex;
  position:absolute;
  right: 170px;
  align-self: center;
  background-color: #004a93;
  border: none;

  .Select {
    .Select-control {
      background-color: transparent !important;
      width:160px;
      color: white !important;
      font-family: sans-serif;
      border: 1px solid #4077ae;

      &:hover{
        background-color: #1a5c9e !important;
        border: 1px solid #4d81b4;
        cursor: pointer;
      }

      .Select-input{
        width: 1px !important;
        padding: 0;
        background: transparent;
      }

      .Select-arrow-zone{
        position: absolute;
        right: 5px;
        top: 13px;
      }

      .Select-multi-value-wrapper{
        .Select-value{
          padding: 0 15px;

          .Select-value-label{
            color: white !important;
          }
        }
      }
    }

    &.is-open{
      .Select-input{
        background: transparent;
      }
    }
  }

  .Select-value span.Select-value-label::before, .Select-menu-outer .Select-menu .Select-option::before{
    background-image: url(/assets/images/flags/glow-flags.png);
    background-repeat: no-repeat;
    background-size: 128px;
    background-position: 0px 0px;
    width: 28px;
    height: 22px;
    content: " ";
    display: inline-block;
    vertical-align: middle;
    margin-right: 10px;
  }

  .Select-value{
    &.sv-SE .Select-value-label::before{
      background-position: 0px 0px;
    }
    &.en-GB .Select-value-label::before{
      background-position: -32px 0px;
    }
    &.nl-NL .Select-value-label::before{
      background-position: -64px 0px;
    }
    &.de-DE .Select-value-label::before{
      background-position: -64px -32px;
    }
    &.da-DK .Select-value-label::before{
      background-position: 0px -32px;
    }
    &.pl-PL .Select-value-label::before{
      background-position: -96px -96px;
    }
    &.nb-NO .Select-value-label::before{
      background-position: 0px -64px;
    }
    &.cs-CZ .Select-value-label::before{
      background-position: -64px -64px;
    }
    &.fr-FR .Select-value-label::before{
      background-position: -32px -96px;
    }
    &.lt-LT .Select-value-label::before{
      background-position: -96px 0px;
    }
    &.lv-LV .Select-value-label::before{
      background-position: -96px -32px;
    }
    &.ru-RU .Select-value-label::before{
      background-position: -64px -96px;
    }
    &.fi-FI .Select-value-label::before{
      background-position: 0px -96px;
    }
    &.et-EE .Select-value-label::before{
      background-position: -96px -64px;
    }
    &.es-ES .Select-value-label::before{
      background-position: -32px -32px;
    }
    &.it-IT .Select-value-label::before{
      background-position: -32px -64px;
    }
    &.en-ES .Select-value-label::before{
      background-position: -32px 0px;
    }
    &.fr-MA .Select-value-label::before{
      background-position: -32px -96px;
    }
    &.en-MA .Select-value-label::before{
      background-position: -32px 0px;
    }
  }

  .Select-menu-outer{
    font-family: sans-serif;

    .Select-menu{
      div.Select-option{
        padding: 5px 15px;

        &.sv-SE::before{
          background-position: 0px 0px;
        }
        &.en-GB::before{
          background-position: -32px 0px;
        }
        &.nl-NL::before{
          background-position: -64px 0px;
        }
        &.de-DE::before{
          background-position: -64px -32px;
        }
        &.da-DK::before{
          background-position: 0px -32px;
        }
        &.pl-PL::before{
          background-position: -96px -96px;
        }
        &.nb-NO::before{
          background-position: 0px -64px;
        }
        &.cs-CZ::before{
          background-position: -64px -64px;
        }
        &.fr-FR::before{
          background-position: -32px -96px;
        }
        &.lt-LT::before{
          background-position: -96px 0px;
        }
        &.lv-LV::before{
          background-position: -96px -32px;
        }
        &.ru-RU::before{
          background-position: -64px -96px;
        }
        &.fi-FI::before{
          background-position: 0px -96px;
        }
        &.et-EE::before{
          background-position: -96px -64px;
        }
        &.es-ES::before{
          background-position: -32px -32px;
        }
        &.it-IT::before{
          background-position: -32px -64px;
        }
        &.en-ES::before{
          background-position: -32px 0px;
        }
        &.fr-MA::before{
          background-position: -32px -96px;
        }
        &.en-MA::before{
          background-position: -32px 0px;
        }
      }
    }
  }
`;

const getSumOfAllMissingRequiredFields = (requiredInputFields = [], validationErrors = []) => {
  const numberOfRequiredFields = requiredInputFields.reduce((sum, current) => sum + current.numberOf, 0);
  const numberOfValidationErrors = validationErrors.reduce((sum, current) => sum + current.numberOf, 0);

  return numberOfRequiredFields + numberOfValidationErrors;
};

const renderAllFieldsInRequiredField = (requiredInputFields, validationErrors, activeDepartureId, incompletePassportFieldsText, guestLabel, wrongFormatLabel, missingLabel) => {
  const mergedErrors = requiredInputFields.concat(validationErrors);
  const uniqueErrors = mergedErrors.filter((item, pos) => mergedErrors.indexOf(item) === pos);
  return uniqueErrors.map(el => (
    <GuestWarning
      key={el.guestId}
      id={el.guestId}
      departureId={activeDepartureId}
      incompletePassportFieldsText={incompletePassportFieldsText}
      missingFields={el.fields}
      guestLabel={guestLabel}
      wrongFormatLabel={wrongFormatLabel}
      missingLabel={missingLabel}
    />
  ));
};

const renderWarning = (requiredInputFields, validationErrors, onRequiredFieldToggleExpanded, headerRequiredFieldToggle, errorsText, activeDepartureId, incompletePassportFieldsText, guestLabel, wrongFormatLabel, missingLabel) =>
 requiredInputFields.length > 0 || validationErrors.length > 0 ?
    (<InputFieldRequired role="button" id="input-field-require" tabIndex={0} className={headerRequiredFieldToggle ? 'expanded' : ''} onClick={onRequiredFieldToggleExpanded}>
      <InputFieldRequiredTitleContainer>
        <InputFieldRequiredError className="img-error" src="/assets/images/error.svg" alt="Error" />
        <InputFieldRequiredTitle>
          <span>{getSumOfAllMissingRequiredFields(requiredInputFields, validationErrors)}</span>
          {errorsText.toLowerCase()}
        </InputFieldRequiredTitle>
        <InputFieldRequiredArrow className={headerRequiredFieldToggle ? 'expanded' : ''} src="/assets/images/arrow-red.svg" alt="Arrow" title="Arrow" />
        {headerRequiredFieldToggle ? <DropDownFieldRequired>{renderAllFieldsInRequiredField(requiredInputFields, validationErrors, activeDepartureId, incompletePassportFieldsText, guestLabel, wrongFormatLabel, missingLabel)}</DropDownFieldRequired> : null}
      </InputFieldRequiredTitleContainer>
    </InputFieldRequired>
  )
  : null;

const Header = ({
  reservationCode,
  numberOfVisaRequired,
  requiredInputFields,
  validationErrors,
  onRequiredFieldToggleExpanded,
  stickHeader,
  headerRequiredFieldToggle,
  cabinsAllocated,
  checkinStarted,
  activeDepartureId,
}) => (
  <T
    text={[
      AppText.MainHeading,
      AppText.ReservationCode,
      AppText.CabinsAllocatedInfo,
      AppText.CheckInStartedInfo,
      AppText.VisaExplaination,
      AppText.Errors,
      AppText.BrowserWarningHeader,
      AppText.BrowserWarningDescription,
      AppText.BrowserWarningButtonText,
      AppText.IncompletePassportFieldsText,
      AppText.GuestLabel,
      AppText.WrongFormat,
      AppText.Missing,
    ]}
    render={([
      mainHeading,
      reservationCodeText,
      cabinsAllocatedInfo,
      checkInStartedInfo,
      visaExplaination,
      errors,
      bwHeader,
      bwDescription,
      bwButtonText,
      incompletePassportFieldsText,
      guestLabel,
      wrongFormatLabel,
      missingLabel,
    ]) => (
      <BgGrid>
        <BrowserWarningContainer
          header={bwHeader}
          description={bwDescription}
          buttonText={bwButtonText}
        />
        {reservationCode ? stickHeader() : null}
        <ContainerHeader id="header">
          <LogoHandler />
          <GlowHeadingWhite>{mainHeading}</GlowHeadingWhite>
          <ImportFileContainer />
          <LanguageSection>
            <LanguageDropdownContainer />
          </LanguageSection>
          <ReservationChooser>
            {reservationCodeText}
            <span>{reservationCode}</span>
          </ReservationChooser>
        </ContainerHeader>
        {reservationCode ?
          <SaveAndErrorArea id="save-and-error-area">
            <SaveAndErrorAreaRow>
              {
                  renderWarning(
                    requiredInputFields,
                    validationErrors,
                    onRequiredFieldToggleExpanded,
                    headerRequiredFieldToggle,
                    errors,
                    activeDepartureId,
                    incompletePassportFieldsText,
                    guestLabel,
                    wrongFormatLabel,
                    missingLabel,
                  )
              }
              <AllocInfo className={!cabinsAllocated ? 'hidden' : ''}>
                <img src="/assets/images/varning.svg" alt="" /><p>{checkinStarted ? checkInStartedInfo : cabinsAllocatedInfo}</p>
              </AllocInfo>
              { reservationCode && numberOfVisaRequired > 0 ? <VisumArea>{numberOfVisaRequired} {visaExplaination}</VisumArea> : null }
              <ServerSaveStatus />
            </SaveAndErrorAreaRow>
          </SaveAndErrorArea>
        : null }
      </BgGrid>
  )}
  />
);

Header.propTypes = {
  reservationCode: PropTypes.string,
  numberOfVisaRequired: PropTypes.number,
  requiredInputFields: PropTypes.array,
  validationErrors: PropTypes.array,
  saveStatus: PropTypes.object,
  onRequiredFieldToggleExpanded: PropTypes.func,
  stickHeader: PropTypes.func,
  headerRequiredFieldToggle: PropTypes.bool,
  cabinsAllocated: PropTypes.bool,
  checkinStarted: PropTypes.bool,
  activeDepartureId: PropTypes.string,
  languages: PropTypes.array,
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/organisms/Header/index.js